export default __webpack_public_path__ + "ae2bf95a7531d5cb914c87cb16cab160.png";